import * as React from 'react';

type ErrorBoundaryState = {
    error: Error | null;
    errorInfo: React.ErrorInfo | null;
};

type ErrorBoundaryProps = {
    children: React.ReactNode;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({ error, errorInfo });  
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <div className="p-5">
                    <h2>Something went wrong.</h2>
                    <p>Please contact support.</p>
                    <details style={{ whiteSpace: 'pre-wrap', color: 'red' }}>
                        {this.state.error && this.state.error.toString()}
                        <br/>
                        {this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }

        return this.props.children;
    }
}
  